import { Component, ChangeDetectionStrategy } from '@angular/core';

/**
 * Drop this tag once in a layout/page and then call AppConfirmService
 * to trigger confirms programmatically.
 *
 * Example:
 *   <!-- in template -->
 *   <app-confirm-dialog></app-confirm-dialog>
 *
 *   <!-- in component -->
 *   this.confirmService.confirm({
 *     message: 'Delete this order?',
 *     accept: () => this.deleteOrder(),
 *   });
 */
@Component({
  selector: 'app-confirm-dialog',
  template: `
    <p-confirmDialog
      [style]="{ minWidth: '26rem' }"
      acceptButtonStyleClass="p-button p-button-sm-outline"
      rejectButtonStyleClass="p-button p-button-sm">
    </p-confirmDialog>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AppConfirmDialogComponent {}
